import { memo, ReactElement, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { selfServiceRoutes } from '../utils';
import { useRequestSelfServiceSession } from '../../../api/mutations/selfService/useRequestSelfServiceSession';
import SessionLoadingScreen from '../SessionLoadingScreen';

export const SessionRequest = memo(function (): ReactElement {
  const navigate = useNavigate();
  const { jobsiteId } = useParams<{ jobsiteId: string }>();
  const { mutateAsync: requestSession } = useRequestSelfServiceSession();
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    if (!jobsiteId) {
      navigate('/*', { replace: true });
      return;
    }

    // Prevent duplicate requests in React Strict Mode
    if (hasRequestedRef.current) {
      return;
    }
    hasRequestedRef.current = true;

    const validJobsiteId = jobsiteId;
    async function handleRequestSession() {
      try {
        const sessionId = await requestSession({ jobsiteId: validJobsiteId });
        navigate(selfServiceRoutes.sessionMain(validJobsiteId, sessionId), { replace: true });
      } catch (error) {
        console.error('Failed to create self-service session:', error);
        navigate(selfServiceRoutes.sessionError(jobsiteId!), { replace: true });
      }
    }

    handleRequestSession();
  }, [jobsiteId, navigate, requestSession]);

  // Show loading state while the request is in progress
  return <SessionLoadingScreen info={'selfService.connectionStatus.requestProcessing'} />;
});
